import './score-details-table.css';

interface ScoreRow {
  label: string;
  value: string | number;
}

interface ScoreDetailsTableProps {
  rows: ScoreRow[];
}

export const ScoreDetailsTable: React.FC<ScoreDetailsTableProps> = ({ rows }) => (
  <div className='score-details'>
    <table>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            <td className='score-label'>{row.label}</td>
            <td className='score-value'>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
